module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "base.a5d2b23d.svg";